import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState, AuthWithToken } from './auth.state';
import { RouteToLogin, RouteToVerifyEmail } from './routing.state';
import { AuthService } from './auth.service';
import { catchError, EMPTY, of, switchMap } from 'rxjs';

export const authGuardCanActivateFn: CanActivateFn = (route, state) => {
	const store = inject(Store);
	const authService = inject(AuthService);
	const authState = inject(AuthState);
	// const toastService = inject(ToastService);
	const token = authService.getToken();
	// check for token in local cache
	if (!authState.token && !token) {
		console.error('token missing')
		store.dispatch(new RouteToLogin());
		return of(false);
	}
	return store
		.dispatch(new AuthWithToken())
		.pipe(
			switchMap(() => {
				if (authState.dateVerified && authState.dateVerified !== '0000-00-00 00:00:00') {
					return of(true);
				}

				if (!state.url.includes('verify-email')) {
					return store.dispatch(new RouteToVerifyEmail()).pipe(switchMap(() => of(false)));
				}

				return of(true);
			}),
			catchError(() => {
				store.dispatch(new RouteToLogin());
				// Hide all errors from this API
				// toastService.showToast(true, {
				// 	message: err.message || err,
				// });
				return EMPTY;
			})
		);
};
